/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, IconButton, Link, Typography} from "@mui/material";
import logo from "../Recursos/logo_barra.svg";
import {useNavigate} from "react-router-dom";
import {theme} from "../Tema";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";
import {CONTACTOS, REDES, SECCIONES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {marcarEvento} from "../Servicios/Analiticas/marcarEvento";
import {irUrl} from "../Utilidades/irUrl";


const redes = [];


const Footer = () => {
    const navigate = useNavigate()
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [politicas, setPoliticas] = useState([])

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({coleccion: 'adicionales', wheres: w}).then((dox) => {
            if (dox.res) {
                setPoliticas(dox.data)
            }
        })
    }, []);
    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            sx={{backgroundImage: `linear-gradient(135deg, #000000 70%, #009FDF 140%)`, pt: 10, pb: 6}}>

            <Dialogo/>

            <Grid2
                container
                size={11}
                sx={{maxWidth: '1400px', color: 'white', mx: 2, alignItems: 'center'}}>

                <Grid2 container size={{xs: 12, sm: 6, md: 4}}>
                    <img
                        onClick={() => navigate('/Home')}
                        src={logo} height={'auto'} width={'50%'}
                        style={{cursor: 'pointer',}}
                    />
                </Grid2>

                <Grid2
                    container
                    alignItems={'flex-start'}
                    justifyContent={'flex-end'}
                    size={12}
                    sx={{px: {xs: 2, md: 6}}}
                >

                    <Grid2
                        container
                        alignItems={'flex-start'}
                        justifyContent={'flex-end'}
                        spacing={2}
                        size={{xs: 12, sm: 6, md: 3}}
                        sx={{pt: 10}}>

                        {SECCIONES.map((item) => (
                            <Grid2 container size={12}>
                                <Typography sx={{fontSize: 20}}>
                                    {item}
                                </Typography>
                            </Grid2>

                        ))}

                        <Grid2 container size={12} spacing={2}>
                            {REDES.map((item, index) => (
                                <IconButton
                                    onClick={() => irUrl(item.link)}
                                >
                                    <img src={item.img} width={32} height={'auto'}/>
                                </IconButton>
                            ))}
                        </Grid2>

                    </Grid2>

                    <Grid2 container
                           spacing={2}
                           size={{xs: 12, sm: 6, md: 6}} sx={{pt: 10}}>

                        {CONTACTOS.map((contacto) => (

                            <Link

                                key={contacto.nombre}
                                disableElevation={true}
                                sx={{
                                    alignItems: 'center',
                                    width: '100%',
                                    color: 'white',
                                    display: 'block',
                                    fontSize: 16,
                                    fontWeight: 800,
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    },
                                }}>
                                <Grid2 container size={12}>
                                    <Grid2 container size={1}>
                                        <img
                                            onClick={() => navigate('/Home')}
                                            src={contacto.imgBlanco} width={20} height={'auto'}
                                            style={{cursor: 'pointer'}}
                                        />
                                    </Grid2>


                                    <Grid2 container size={11}
                                           sx={{paddingLeft: 2}}>
                                        <Typography sx={{fontSize: sCell ? 18 : 20}}>
                                            {contacto.descripcion}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </Link>
                        ))}
                    </Grid2>

                    <Grid2 container
                           spacing={2}
                           size={{xs: 12, sm: 4, md: 3}} sx={{pt: 10}}>

                        {politicas.map((politica) => (
                            <Grid2 container
                                   onClick={() => {
                                       marcarEvento(politica.nombre)
                                       abrir(politica)
                                   }}
                                   size={12}>


                                <Typography sx={{
                                    color: 'white',
                                    display: 'block',
                                    fontSize: 20,
                                    fontWeight: 400,
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                    },
                                }}>
                                    {politica.titulo}
                                </Typography>


                            </Grid2>
                        ))}
                        <Grid2 container
                               size={12} sx={{pt: 0}}>
                            {redes.map((red, index) => (
                                <Link key={index} target="_blank" rel="noopener"
                                      onClick={() => {
                                          alert(red.url);
                                      }}
                                      sx={{cursor: 'pointer', pr: 4}}>
                                    <img src={red.imagen} alt={red.alt} width={40}/>
                                </Link>
                            ))}
                        </Grid2>
                    </Grid2>

                </Grid2>

                <Grid2 container size={12}>
                    <Typography sx={{textAlign: 'center', width: '100%', mt: 16}}>
                        © Copyright 2026 - 2027 | Fundhap
                    </Typography>
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Footer

